module.exports = __webpack_public_path__ + "img/dang.ae93cc29.png";